import React from 'react'
import { pluralizeToString } from 'lib/string/pluralize'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'

interface Props {
  shipName: string;
  duration: number;
  cruiseLineName: string;
  portLength?: number;
  countryLength?: number;
}

function CruiseDescription(props: Props) {
  const { portLength, shipName, duration, cruiseLineName, countryLength } = props

  return (
    <Group direction="vertical" gap={8}>
      <BodyText variant="small" colour="neutral-two">
        {cruiseLineName} · {shipName}
      </BodyText>
      <BodyText variant="small" colour="neutral-two">
        {pluralizeToString('night', duration)}
        {!!portLength && ` · ${pluralizeToString('port', portLength)}`}
        {!!countryLength && ` · ${pluralizeToString('country', countryLength)}`}
      </BodyText>
    </Group>
  )
}

export default CruiseDescription
